import { BigWinThresholds } from "ags/utils/win-magnitude";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { BonusResult } from "slotworks/model/gameplay/records/results/bonus-result";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";

export class AgsOverAnimateThreshold extends Decision {
    public evaluate(): Exit {
        const record = gameState.getCurrentGame().getCurrentRecord();
        const winRatio = record.cashWon / Services.get(SlotBetService).getTotalStake();

        // Change as of BB-67 to always highlight after a pick bonus
        const isPickBonus = record.getResultsOfType(BonusResult).length > 0;

        return (winRatio >= BigWinThresholds.REGULAR || isPickBonus) ? Exit.True : Exit.False;
    }
}
